import gql from 'graphql-tag';

import sensorSettingsFields from '@/queries/fields/sensorSettingsFields';
import { FavoriteStateFields } from '@/queries/fields/favoriteStateFields';
import lightModeFields from '@/queries/fields/lightModeFields';

const roomFields = gql`
  fragment roomFields on Room {
    id
    name
    type
    provider
    displayOrder
    fadeIn
    fadeOut
    floorId
    favorite1 {
      ...favoriteStateFields
    }
    favorite2 {
      ...favoriteStateFields
    }
    favorite3 {
      ...favoriteStateFields
    }
    favorite4 {
      ...favoriteStateFields
    }
    lights {
      ...lightFields
    }
    groups {
      id
      roomId
      floorId
      name
      fadeIn
      fadeOut
      startupMode
      displayOrder
      position {
        id
        coordX
        coordY
      }
      lights {
        ...lightFields
      }
    }
    position {
      id
      coordX
      coordY
    }
    sensorSettings {
      ...sensorSettingsFields
    }
    rhythmsEnabled
    wifiSensingEnabled
    wifiSensingConfiguration {
      sensitivity
      beaconingNodeId
      processingNodeIds
    }
  }
  ${FavoriteStateFields.fragment}
`;

const roomFieldsJustMetadata = gql`
  fragment roomFieldsJustMetadata on Room {
    id
    name
    type
    displayOrder
    fadeIn
    fadeOut
    favorite1 {
      ...favoriteStateFields
    }
    favorite2 {
      ...favoriteStateFields
    }
    favorite3 {
      ...favoriteStateFields
    }
    favorite4 {
      ...favoriteStateFields
    }
    sensorSettings {
      ...sensorSettingsFields
    }
    rhythmsEnabled
  }
  ${FavoriteStateFields.fragment}
`;

export const roomFieldsJustMetadataQuery = gql`
  query room($id: String!) {
    room(id: $id) {
      ...roomFieldsJustMetadata
    }
  }
  ${roomFieldsJustMetadata}
  ${lightModeFields}
  ${sensorSettingsFields}
`;

export { roomFieldsJustMetadata };
export default roomFields;
